import {
  VTR_LIST_SUCCESS,
  VTR_LIST_ERROR,
  LOGOUT,
  RESET_CACHE,
} from "../actions/actionTypes";
import { encryptVtrList } from "../constants/Encrypt";
import { getStorageValue, removeStorageValue } from "../enhancers/utils";

export default function vtrListReducer(
  state = {
    trips: [],
    encryptedTrips: [],
    isLoaded: false,
    error: {},
  },
  action
) {
  const clientId = action.client_id;
  switch (action.type) {
    case VTR_LIST_SUCCESS:
      if (action.data.hasOwnProperty("DOC_LIST")) {
        state.trips = action.data.DOC_LIST;
        state.encryptedTrips = encryptVtrList(action.data.DOC_LIST, clientId);
        // * note: the app will no longer save the vtrList into local storage.
        // * Added code to remove existing vTrip List from localStorage.
        // todo: remove code by the end of fiscal year.
        if (clientId) {
          const vtrList = getStorageValue("vtrList_" + clientId);
          if (vtrList) {
            removeStorageValue("vtrList_" + clientId);
          }
        }
      } else {
        console.log("ERROR_VTR_REDUCER", action.data);
      }
      state.isLoaded = true;
      delete state.error;
      return { ...state };
    case VTR_LIST_ERROR:
      return { ...state, error: action.error };
    case RESET_CACHE:
      if (clientId) {
        removeStorageValue("vtrList_" + clientId);
      }
      state.trips = [];
      state.encryptedTrips = [];
      state.isLoaded = false;
      return { ...state };
    case LOGOUT:
      //When logging out reset the state so the state comes from the
      // user logged in
      state.trips = [];
      state.encryptedTrips = [];
      state.isLoaded = false;
    // falls through
    default:
      return { ...state };
  }
}
